// 获取注册内容弹窗组件
export function getresetDialogData() {
    return [

        {
            key: "school",
            name: "密码",
            value: '',
            type: 'input',
            isNull: true,

        },
        {
            key: "school",
            name: "密码",
            value: '',
            type: 'input',
            isNull: true,

        },

    ]
}